import { useSyncExternalStore } from 'react';

/**
 * Peticiones en curso de apiClient, para el indicador global (GlobalLoading).
 * `bloqueantes` son las que modifican datos (guardar, anular…): mientras corren se bloquea la
 * pantalla para que no se envíen dos veces.
 */
export interface LoadingState {
  total: number;
  bloqueantes: number;
}

let state: LoadingState = { total: 0, bloqueantes: 0 };
const listeners = new Set<() => void>();

function emit(next: LoadingState) {
  state = next;
  listeners.forEach((listener) => listener());
}

export const loadingTracker = {
  start(bloqueante: boolean) {
    emit({ total: state.total + 1, bloqueantes: state.bloqueantes + (bloqueante ? 1 : 0) });
  },
  end(bloqueante: boolean) {
    emit({
      total: Math.max(0, state.total - 1),
      bloqueantes: Math.max(0, state.bloqueantes - (bloqueante ? 1 : 0)),
    });
  },
};

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useApiLoading(): LoadingState {
  return useSyncExternalStore(subscribe, () => state);
}
